module.exports = __webpack_public_path__ + "img/范蠡归隐.b5315a16.jpg";